export const EBOOK_CATEGORIES = [
  { key: 'classics', label: 'Classics' },
  { key: 'fiction', label: 'Fiction' },
  { key: 'adventure', label: 'Adventure' },
  { key: 'history', label: 'History' },
  { key: 'philosophy', label: 'Philosophy' },
  { key: 'science', label: 'Science' },
  { key: 'education', label: 'Education' },
  { key: 'poetry', label: 'Poetry' },
  { key: 'other', label: 'Other' }, // optional
];
